/*=========================================================================================
  File Name: moduleEmployeeState.js
  Description: Employee Module State
==========================================================================================*/

export default {
	employees: [],
	employeesSearchQuery: "",
	employeesFilter: null,
	total: 0,
	limitPerPage: 10
};
